import React from "react";
import { InstantSearch, connectSearchBox, ClearRefinements, Hits, HitsPerPage, Highlight, RefinementList, Configure, Pagination } from "react-instantsearch-dom";
import PropTypes from 'prop-types'
import { Translation } from "react-i18next";
import i18next from 'i18next';

const algoliasearch = require('algoliasearch');

const client = algoliasearch('27IKA98MKL', '025a2df6474fcef8a91463028c23a68b');
const index = client.initIndex('dev_PRODUCT');

const UlList = ({ data }) => {
    return (
        <div className="react-autosuggest__suggestions-container">
            <ul className="react-autosuggest__suggestions-list" >
                {
                    data.map(item =>
                        <li className="react-autosuggest__suggestion react-autosuggest__suggestion--first">
                            <a className="request-empty-result" herf="{item.url}">
                                <div class="image-container">
                                    <img src={item.image} align="left" alt={item.name} /></div>
                                <div>
                                    <Highlight attribute="name" hit={item} />
                                </div>
                            </a>
                        </li>
                    )
                }
            </ul>
        </div>
    )
}


class NavContainer extends React.Component {
    constructor(props) {
        super(props)
        this.searchRef = React.createRef()
        this.focus_search = this.focus_search_index.bind(this)
        this.state = {
            data_list: [],
        }
    }
    onKeyDown = (e) => {
    }
    onChange = (e) => {
        const value = e.target.value
        this.setState({
            query: value
        })
        if (value === '') {
            this.setState({
                data_list: []
            })
        }
    }

    getQuery = () => this.state.query;
    Hit(props) {
        return (
            <div className="search-autocomplete-result">
                <img src={props.hit.image} align="left" alt={props.hit.name} />
                <div className="hit-name">
                    <Highlight attribute="name" hit={props.hit} />
                </div>
                {/* <div className="hit-description">
                    <Highlight attribute="description" hit={props.hit} />
                </div> */}
                {/* <div className="hit-price">${props.hit.price}</div> */}
            </div>
        );
    }

    focus_search_index(e) {
        let that = this
        index.search(e.currentTarget.value).then(({ hits }) => {
            console.log(hits);
            that.setState({
                data_list: hits
            })
        })
    }
    render() {
        // const SearchBox = ({ isSearchStalled }) => ()
        // const CustomSearchBox = connectSearchBox(SearchBox);
        const query = this.getQuery();

        return (

            <div className="max-width-container header-width-container">
                <div>
                <Translation>
                    {(t) => <h1>{t("home.title-h1")}</h1>}
                </Translation>
                </div>
                <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-5" >
                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-12">
                        <Translation>
                            {(t) => <h1>{t("home.title")}</h1>}
                        </Translation>
                        <h2 className="description">
                            <Translation>
                                {(t) => <p>{t("home.subtitle")}</p>}
                            </Translation>
                        </h2>
                        <div className="search-container">
                            <div className="search-autocomplete-container" >
                                <div className="search-autocomplete-suggest">
                                    <InstantSearch searchClient={client} indexName="dev_PRODUCT">
                                        {/* <ClearRefinements /> */}
                                        <div className="search-input-container">
                                            <div className="icon-container" onClick={this.focus_search}>
                                                <svg width="24" height="24" viewBox="0 0 24 24">
                                                    <path fill="#999"
                                                        d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z">
                                                    </path>
                                                </svg>
                                            </div>
                                            <Translation>
                                                {(t) =>
                                                    <input type="search"
                                                        onChange={this.onChange}
                                                        autoFocus={false}
                                                        spellCheck="false"
                                                        value={query}
                                                        required
                                                        maxLength="128"
                                                        className="react-autosuggest__input"
                                                        placeholder={i18next.t('home.search-content')} ></input>
                                                }
                                            </Translation>
                                        </div>
                                        <UlList data={this.state.data_list} />
                                        {/* <Hits hitComponent={this.Hit} /> */}
                                        {/* <RefinementList
                                        translations={{
                                            showMore(expanded) {
                                                return expanded ? 'Show less' : 'Show more';
                                            },
                                            noResults: 'No results',
                                            submitTitle: 'Submit your search query.',
                                            resetTitle: 'Clear your search query.',
                                            placeholder: 'Search here...',
                                        }}
                                    /> */}
                                        {/* <HitsPerPage defaultRefinement={5} items={[
                                        { value: 5, label: 'Show 5 hits' },
                                        { value: 10, label: 'Show 10 hits' },
                                    ]} /> */}
                                        {/* <Pagination /> */}
                                    </InstantSearch>
                                </div>
                                <div className="search-autocomplete-history">
                                    <div ><p>Recent searches</p></div>
                                    <div className="search-history-div"><ul className="search-history-content" >
                                        <li>华为</li>
                                        <li>小米</li>
                                        <li>阿里</li>
                                    </ul></div>
                                    <div>Managed History</div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="search-container">
                        <div className="search-autocomplete-container" >
                            <div aria-haspopup="listbox" aria-owns="react-autowhatever-1"
                                aria-expanded="false" className="react-autosuggest__container">
                                <div className="search-input-container">
                                    <div className="icon-container">
                                        <svg width="24" height="24" viewBox="0 0 24 24">
                                            <path fill="#999"
                                                d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z">
                                            </path>
                                        </svg>
                                    </div>
                                    <input type="text" onBlur={this.select_index}
                                        aria-controls="react-autowhatever-1"
                                        className="react-autosuggest__input"
                                        placeholder="Search for branding, products, ..."
                                        aria-activedescendant="react-autowhatever-1--item-0" />
                                </div>
                                <div id="react-autowhatever-1" role="listbox"
                                    className="react-autosuggest__suggestions-container"></div>
                            </div>
                        </div>
                    </div> */}
                    </div>
                </div>
            </div>
        )
    }
}



export default NavContainer;
